export const AUTH_COOKIE = 'oauth2_authenticated';
export const ANALYTICS_GA4_EVENTS_COOKIE = 'ga4-events';
